import { buildQueryString, ServiceMaker } from ".";

export const assignRightsCityWise = (data: any) => ServiceMaker('platformServiceRights/assign', 'POST', data);

export const getRightsCityWise = (data?: any) => ServiceMaker(`platformServiceRights/list?${buildQueryString(data)}`, 'GET');

export const getRightsCityCompanyWise = (data?: any) => ServiceMaker(`platformServiceRights/list/byCompany?${buildQueryString(data)}`, 'GET');